class MicroCart extends HTMLElement {
  constructor() {
    super()
  }
}

customElements.define('pack-builder-micro-cart', MicroCart);

class PackBuilderMicroCartListToggleButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (evt) => {
      evt.preventDefault()
      const microCartWrapper = document.getElementById('micro-cart__wrapper')
      microCartWrapper.classList.toggle('micro-cart__wrapper-collapsed')
    })
  }
}

customElements.define(
  'pack-builder-micro-cart-list-toggle-button', PackBuilderMicroCartListToggleButton
);

class PackBuilderMicroCartRemoveButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (evt) => {
      evt.preventDefault()
      this.removeFromCart()
    })
  }

  removeFromCart() {
    let formData = new FormData(this.form);
    const vid = this.getAttribute('data-variant-id')
    let updates = { [vid]: 0 }

    // add loading states
    document.querySelector('.micro-cart__items.micro-cart__items-collapsed')
      .classList.add('micro-cart__updating')

    document.querySelector('.micro-cart__checkout-btn-wrapper')
      .classList.add('micro-cart__updating')

    const fetchOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, fetchOptions)
      .then(async (response) => {
        if (response.ok) {
          document.dispatchEvent(new Event('microcartremove'));
          document.dispatchEvent(new Event('cart:refresh'));
          reRenderAnnouncementBarAndMicroCartAndCartCount()
        }

        // remove loading states
        document.querySelector('.micro-cart__items.micro-cart__items-collapsed')
          .classList.remove('.micro-cart__updating')

        document.querySelector('.micro-cart__checkout-btn-wrapper')
          .classList.remove('.micro-cart__updating')

        return response.json()
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }
}

customElements.define(
  'pack-builder-micro-cart-remove-button', PackBuilderMicroCartRemoveButton
);

class PackBuilderMicroCartCheckoutButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (evt) => {
      evt.preventDefault()
      window.location.href = window.Shopify.routes.root + 'checkout'
    })
  }
}

customElements.define(
  'pack-builder-micro-cart-checkout-button', PackBuilderMicroCartCheckoutButton
);

async function reRenderAnnouncementBarAndMicroCartAndCartCount() {
console.log(offBannerId);
  const response = await fetch(
    `${window.location.pathname}?sections=${packBuilderId},${offBannerId}`
  );
  const html = await response.json();
  
  function extractCustomElementHTML(sectionHTML, customTag) {
    console.log(customTag,sectionHTML);
    const openingTag = sectionHTML.match(new RegExp('<' + customTag + '[^>]*>'));
    const closingTag = `</${customTag}>`
    if (openingTag)
      return openingTag + sectionHTML.split(openingTag)[1].split(closingTag)[0] + closingTag;
  }

  const packBuilderMicroCartParent =
    document.querySelector('#micro-cart__wrapper').parentElement;
  if (packBuilderMicroCartParent) {
    const updatedHTML =
      extractCustomElementHTML(html[packBuilderId], 'pack-builder-micro-cart');
    packBuilderMicroCartParent.innerHTML = updatedHTML;
  }

  const offBannerParent =
  document.querySelector('.off-banner');
  if (offBannerParent) {
   
    offBannerParent.innerHTML = html[offBannerId];
  }
}
document.addEventListener('variant:add',function(evt){
  console.log("added successfully");
  
  // Close quick-buy-drawer when a variant is added
  const quickBuyDrawer = document.querySelector('quick-buy-drawer');
  if (quickBuyDrawer) {
    quickBuyDrawer.hide();
  }
})
document.addEventListener('variant:add', function(){

  // we need to get quick-buy-drawer which has open attribute
  const quickBuyDrawer = document.querySelector('quick-buy-drawer[open]');
  if (quickBuyDrawer) {
    quickBuyDrawer.hide();
  }
  reRenderAnnouncementBarAndMicroCartAndCartCount();
});
document.addEventListener('cartaddsuccess', reRenderAnnouncementBarAndMicroCartAndCartCount)
document.addEventListener('cart:change', reRenderAnnouncementBarAndMicroCartAndCartCount)
document.addEventListener('cartupdatesuccess', reRenderAnnouncementBarAndMicroCartAndCartCount)

// --- Progress Bar Logic for Off Banner ---
document.addEventListener('DOMContentLoaded', function() {
  const thresholdsScript = document.getElementById('pack-thresholds');
  if (!thresholdsScript) return;
  const thresholds = JSON.parse(thresholdsScript.textContent);
  const progressBar = document.querySelector('#pack-progress-bar-container .progress-bar-inner');
  const progressBarOuter = document.querySelector('#pack-progress-bar-container .progress-bar-outer');
  const progressMessage = document.getElementById('pack-progress-message');

  function updateProgressBar(currentCount) {
    if (!progressBar || !progressBarOuter) return;
    // Sort thresholds ascending
    const sorted = thresholds.slice().sort((a, b) => a.threshold - b.threshold);
    let next = sorted.find(t => currentCount < t.threshold);
    let prev = sorted.slice().reverse().find(t => currentCount >= t.threshold);
    let max = next ? next.threshold : (prev ? prev.threshold : 1);
    let value = currentCount;
    let percent = Math.min(100, (value / max) * 100);
    progressBar.style.width = percent + '%';
    // Update message
    if (next) {
      let toGo = next.threshold - currentCount;
      progressMessage.textContent = `Add ${toGo} more item${toGo > 1 ? 's' : ''} to get ${next.discount} off`;
    } else if (prev) {
      progressMessage.textContent = `You've unlocked ${prev.discount} off!`;
    } else {
      progressMessage.textContent = '';
    }
  }

  // Listen for custom event
  document.addEventListener('pack:item:add', function(e) {
    if (e.detail && typeof e.detail.count === 'number') {
      updateProgressBar(e.detail.count);
    }
  });

  // Optionally, initialize on page load
  updateProgressBar(0);

  // Add CSS if not present
  if (!document.getElementById('off-banner-progress-bar-style')) {
    const style = document.createElement('style');
    style.id = 'off-banner-progress-bar-style';
    style.textContent = `
      .progress-bar-outer {
        width: 100%;
        height: 8px;
        background: #eee;
        border-radius: 4px;
        margin-top: 10px;
        overflow: hidden;
      }
      .progress-bar-inner {
        height: 100%;
        background: #661b62;
        border-radius: 4px 0 0 4px;
        transition: width 0.4s;
      }
    `;
    document.head.appendChild(style);
  }
}); 